"use client"

import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import "@/src/extensions/number"
import ConfigProductBySize from './config-product-by-size/config-product-by-size'
import { useCurrentProduct } from '@/src/context/product/current-product-context'
import ItemInfos from '@/src/interfaces/catalog/item-infos'

interface Props {
    sizes: ItemInfos.Size[]
}

export default function SizeProduct({ sizes }: Props) {
    const [isMoveNext, setIsMoveNext] = useState(false)
    const [sizeChosen, setSizeChosen] = useState<ItemInfos.Size>()
    const { setPrice, setHasSelectedSize, setAnswersFromCustomer } = useCurrentProduct()

    const moveNext = (size: ItemInfos.Size) => {
        setSizeChosen(size)
        setHasSelectedSize(true)
        setIsMoveNext(true)
    }

    const reset = () => {
        setIsMoveNext(false)
        setSizeChosen(undefined)
        setHasSelectedSize(false)
        setPrice(0)
        setAnswersFromCustomer([])
    }

    useEffect(() => {
        setPrice(0)
    }, [])

    if (!isMoveNext && !sizeChosen) {
        return (
            <div className={styles.container}>
                <h3 className='font-xmd'>Selecione o tamanho:</h3>
                <div className={styles.sizeContent}>
                    {
                        sizes && sizes.map((item) => (
                            <div className={styles.cardSize} key={item.id} id={item.itemId} onClick={() => moveNext(item)}>
                                <span className={`font-lg ${styles.acronym}`}>{item.acronym}</span>
                                <span className={styles.title}>{item.name}</span>
                                <b className={styles.price}>{item.salePrice?.toLocalePrice()}</b>
                            </div>
                        ))
                    }
                </div>
            </div>
        )
    }
    else {
        return (
            <ConfigProductBySize moveBack={reset} sizeChosen={sizeChosen!} />
        )
    }
}
